import { DragAndDrop, FormFieldErrorInfo, Iconsvg, SegmentedControl, SegmentedControlItem, SelectField, TextareaField, UploadStatus } from '@wk/components-react16';
import { createRef, useState } from 'react';


const GetSmartPrompt = ({ data }: any) => {
    const { documentFile, setDocumentFile, documentText, setDocumentText, fileList, setFileList, summary, setSummary, documentList, tryNowdocumentBatchList, setTryNowdocumentBatchList } = data;
    const storyContainer = createRef<any>();
    let id = 0;
    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleSegmentChange = (event: any) => {
        setSelectedIndex(event);
        if (event == 0) {
            setFileList([]);
        } else {
            setDocumentText('');
        }
    }

    const handleSelectDocument = (value: any) => {
        if (value) {
            setDocumentFile(value);
            setFileList([]);
            setDocumentText('');
            tryNowdocumentBatchList.forEach((item: any) => {
                if (item.code != value) {
                    item.status = false;
                }
            });
            setTryNowdocumentBatchList([...tryNowdocumentBatchList]);
        } else {
            setDocumentFile('');
            tryNowdocumentBatchList.forEach((item: any) => item.status = true);
            setTryNowdocumentBatchList([...tryNowdocumentBatchList]);
        }
    }

    const handleDocumentText = (value: any) => {
        if (value) {
            setDocumentText(value);
            setDocumentFile('');
        } else {
            setDocumentText('');
        }
    }

    const handleFilesChange = (event: any) => {
        const targetFiles = Array.isArray(event) ? event : Array.from(event.target.files);
        if (targetFiles.length > 0) {
            setDocumentFile('');
        }
        const newFileItems = targetFiles.map((file: File) => {
            const uiFile = {
                id: _nextId(),
                nativeFile: file,
                label: file.name,
                type: file.type,
                progress: 100,
            };
            return {
                ...uiFile,
                status: 'completed',
            };
        });

        const newFileList: any = [];
        setFileList([...newFileItems, ...newFileList]);
    }

    const handleFileItemClick = (file: any) => {
        if (file.status !== 'uploading') {
            setFileList(fileList.filter((f: any) => f.id !== file.id));
            const nativeInput =
                storyContainer.current.ownerDocument.querySelector(
                    'input[type="file"]'
                ) as HTMLInputElement;
            nativeInput.value = '';
        }
    }

    const _nextId = () => {
        id += 1;
        return 'i-' + id;
    }

    const getErrors = (): Array<FormFieldErrorInfo> => {
        return fileList.filter((f: any) => f.errorMsg).map((f: any) => ({ label: f.errorMsg, labelId: f.id }));
    }

    const getErrorIds = () => {
        return getErrors().map((e: any) => e.labelId).join(',');
    }

    const getIconName = (file: any) => {
        if (file.type.includes('pdf')) {
            return 'file-pdf';
        } else if (file.type.includes('jpeg') || file.type.includes('png')) {
            return 'photo';
        } else {
            return 'file';
        }
    }

    return (
        <div className='position-relative'>
            <h4 className='mb-20'>Smart Prompt</h4>
            <div className="cg-field-header" style={{ fontSize: '0.875rem' }}>
                <label className="cg-field-label">Enter Input as
                    <div className="cg-field-required-indicator"><span aria-hidden="true">*</span></div>
                </label>
            </div>
            <SelectField label="" labelFor="select-id-4">
                <select id="select-id-4" name="documentFile"
                    onChange={(event: any) => handleSelectDocument(event.target.value)}
                    value={documentFile || ''}>
                    <option value="">-- Select document --</option>
                    {documentList.map((item: any, i: number) => <option value={item.code} key={i}>{item.name}</option>)}
                </select>
            </SelectField>
            <div className='mb-20 text-center'>-- OR --</div>
            <div className='custom-segmented-control'>
                <SegmentedControl
                    selectedIndex={selectedIndex}
                    controlMode={'controlled'}
                    onUserRequest={(event: any) => handleSegmentChange(event)}>
                    <SegmentedControlItem slot="segmentedControlItem">
                        Document Text
                    </SegmentedControlItem>
                    <SegmentedControlItem slot="segmentedControlItem">
                        Document Upload
                    </SegmentedControlItem>
                </SegmentedControl>
            </div>
            {selectedIndex == 0 ? (
                <div className="mb-15 mt-5">
                    <TextareaField labelFor="textarea-id-2" indicator="required">
                        <textarea style={{ height: '10rem' }}
                            id="textarea-id-2" name="documentText"
                            placeholder="Document Text"
                            onChange={(event: any) => handleDocumentText(event.target.value)}
                            value={documentText}
                        ></textarea>
                    </TextareaField>
                </div>
            ) : (
                <div className="mb-15 mt-5" ref={storyContainer}>
                    <DragAndDrop
                        acceptTypes=".xlsx,.docx,.json,.png,.jpg,.jpeg" size="medium"
                        onFilesChange={(event: any) => handleFilesChange(event)} isMultiple={false}>
                        <input
                            id="file-upload-001"
                            type="file"
                            name="file-upload"
                            accept=".xlsx,.docx,.json,.png,.jpg,.jpeg"
                            aria-describedby={getErrorIds()}
                            onChange={(event: any) => handleFilesChange(event)}
                            slot="dragAndDropInput"
                        />
                        {fileList.map((item: any, i: number) =>
                            <UploadStatus
                                key={i}
                                label={item.label}
                                status={item.status}
                                size={item.nativeFile.size}
                                progress={item.progress}
                                isCompact
                                onItemClick={() => handleFileItemClick(item)}
                                slot="dragAndDropListItem">
                                <Iconsvg name={getIconName(item)}></Iconsvg>
                            </UploadStatus>
                        )}
                    </DragAndDrop>
                    <div className='mt-5 wk-size-1 text-warning-emphasis'>Accepted formats: Excel, Word (DOCX), JSON, PNG, JPG/JPEG.</div>
                </div>
            )}
            <div className="">
                <TextareaField label="Prompt Summary Text" labelFor="textarea-id-1" indicator="required">
                    <textarea style={{ height: '10rem' }}
                        id="textarea-id-1" name="text"
                        placeholder="Prompt Summary Text"
                        onChange={(event: any) => setSummary(event.target.value)}
                        value={summary}
                    ></textarea>
                </TextareaField>
            </div>
        </div>
    );
};

export default GetSmartPrompt;